module.exports = __webpack_public_path__ + "static/zuri-hybrid-vtol-front-view-distributed-propulsion-spinning-propellers-f1c73974c7078bfde6a7802bb668f2a3.mp4";